import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import ContentTracking from 'services/api/ContentTracking';
import isSharedDocumentsWebUrl from 'utils/isSharedDocumentsWebUrl';

/**
 * Markdown link in chat: Shared Documents URLs navigate in-app; others open in a new tab.
 * Modifier clicks (new tab / window) are left to the browser.
 */
const ChatMarkdownLink = ({ href, children = null, messageId }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(
    event => {
      if (messageId) {
        ContentTracking.trackLinkClick({ messageId, url: href });
      }
      if (!href || !isSharedDocumentsWebUrl(href)) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }
      event.preventDefault();
      try {
        const u = new URL(href, window.location.href);
        navigate(`${u.pathname}${u.search}${u.hash}`);
      } catch {
        /* fall through: browser follows href */
      }
    },
    [href, messageId, navigate],
  );

  const inAppShared = href && isSharedDocumentsWebUrl(href);

  return (
    <a
      href={href}
      {...(inAppShared ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};

ChatMarkdownLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  messageId: PropTypes.string,
};

export default ChatMarkdownLink;
